<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditCompradorDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <DetalheCompradorDialog :item="item" v-model="detalheDialogOpened"/>

    <div>
      <CompradorDataTable ref="dataTable"
                             @click:edit="editar"
                             @click:verDetalhe="verDetalhe"
                             @click:remove="remover"
                             @click:aprovarCadastro="aprovar"
                             @click:reprovarCadastro="reprovar"
                             @click:suspenderCadastro="suspender"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import CompradorDataTable from "../../components/shared/datatables/CompradorDataTable";
import BaseView from "../BaseView";
import {findOne,remove, mudarStatus} from "../../api/comprador";
import CreateEditCompradorDialog from "../../components/shared/dialogs/CreateEditCompradorDialog";
import DetalheCompradorDialog from "../../components/shared/dialogs/DetalheCompradorDialog";
import {ApiError} from "../../api/core";
import {mapActions,mapGetters} from "vuex";
import {ItemDeDominio} from "../../api/itemsDominio";
//PKs
import {findAll as findAllAtividadeEconomica} from "../../api/atividadeEconomica";

export default {
  name: "index",
  components: {CreateEditCompradorDialog, DetalheCompradorDialog, BaseView, CompradorDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      detalheDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'ID',
          column: 'id',
          type: 'number',
          prefix: '#'
        },
        {
          name: 'Nome',
          column: 'nome',
          type: 'text'
        },        
        {
          name: 'Descricao',
          column: 'descricao',
          type: 'text'
        },
        {
          name: 'CNPJ',
          column: 'cnpj',
          type: 'text'
        },
        {
          name: 'Estado',
          column: 'estado',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.COMBO_ESTADO
          })
        },           
        // {
        //   name: 'Atividade Econômica',
        //   column: 'idAtividadeEconomica',
        //   type: 'autocomplete',
        //   optionsFactory: (search) => findAllAtividadeEconomica(1,{
        //     nome: search
        //   })
        //       .then(r => {
        //         return r.elements.map(e => ({
        //           key: e.id,
        //           valor: e.descricao
        //         }))
        //       })
        // },
        {
          name: 'Status',
          column: 'flgStatus',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.STATUS_MODERACAO
          })
        },  
        {
          name: 'Empresa Estrangeira',
          column: 'flgEmpresaEstrangeira',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.FLG_PADRAO
          })
        },
        {
          group: 'Data Cadastro',
          columns: [
            {
              name: 'Inicio',
              column: 'dtInicio',
              type: 'date',
            },
            {
              name: 'Fim',
              column: 'dtFim',
              type: 'date',
            },
          ]
        },           
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {
        id: null,
        idAtividadeEconomica: null,
        descricaoAtividadeEconomica: "",
        nomeFantasia: "",
        razaoSocial: "",
        descricao: "",
        flgEmpresaEstrangeira: "N",
        cnpj: "",
        senha: "",
        endereco: "",
        bairro: "",
        complemento: "",
        cidade: "",
        estado: "",
        cep: "",
        pais: "",
        telefone: "",
        email: "",
        siteRede: "",
        contatos: [],
      };
      this.editDialogOpened = true;
    },
    async getComprador(id){
      try {
        const retorno = await findOne(id);
        return retorno.dados[0];
      } catch (err) {
        throw err;
      }
    },
    async editar(objeto) {
      try {
        this.loading = true;
        const comprador = await this.getComprador(objeto.id);
        this.item = comprador;
        this.editDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Comprador. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    },
    async verDetalhe(objeto) {
      try {
        this.loading = true;
        const comprador = await this.getComprador(objeto.id);
        this.item = comprador;
        this.detalheDialogOpened = true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Comprador. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
      } finally {
        this.loading = false;
      }
    }, 
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Comprador removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {        
          this.$toast.error(`Não foi possível remover o Comprador.`, {
            timeout: 6000
          })
        }  
      } finally {
        this.loading = false;
      }
    },
    async aprovar(obj) {
      try {
        this.loading = true;
        await mudarStatus(obj.id, {flgStatus: 'A'});
        this.$toast.success(`Cadastro do Comprador aprovado com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível aprovar o Cadastro do Comprador.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
    async reprovar(obj) {
      try {
        this.loading = true;
        await mudarStatus(obj.id, {flgStatus: 'R'});
        this.$toast.success(`Cadastro do Comprador reprovado com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível reprovar o Cadastro do Comprador.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
    async suspender(obj) {
      try {
        this.loading = true;
        await mudarStatus(obj.id, {flgStatus: 'S'});
        this.$toast.success(`Cadastro do Comprador suspenso com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível suspender o Cadastro do Comprador.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("Comprador.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>